import { render, staticRenderFns } from "./CmgGooglePayButton.vue?vue&type=template&id=0433a226&scoped=true&lang=pug"
import script from "./cmg-google-pay-button.ts?vue&type=script&lang=ts&external"
export * from "./cmg-google-pay-button.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgGooglePayButton.vue?vue&type=style&index=0&id=0433a226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0433a226",
  null
  
)

export default component.exports